module.exports = __webpack_public_path__ + "static/img/qr.855917d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr.gif
// module id = 9X05
// module chunks = 17